import {
  AUTH_TOKEN_STORAGE,
  IS_MOBILE_APP,
} from "../constants/localStorageKeys";
import { setApiBaseUrlForRegion } from "../services/api";
import { tenantService } from "../services/tenantService";
import { rehydrateColorsPatchMobile } from "./theme";

export async function handleMobileWebView(token: string) {
  const tokenJson = `{"tokenType":"Bearer","idToken":"${token}"}`;
  window.localStorage.setItem(AUTH_TOKEN_STORAGE, tokenJson);
  window.localStorage.setItem(IS_MOBILE_APP, "true");

  const data = await tenantService.getTenantDetails();

  if (data && data.region) {
    await setApiBaseUrlForRegion(data.region);
  }

  if (data && data.tenantStyles) {
    rehydrateColorsPatchMobile(data.tenantStyles);
  }
}
